import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { SpinnerManualService } from '@core/services/internal/spinner-manual.service';

@Component({
  selector: 'app-spinner-manual',
   standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner-manual.component.html',
  styleUrls: ['./spinner-manual.component.scss']
})
export class SpinnerManualComponent {
  isLoading = this.spinnerSvc.isLoading;
  message = this.spinnerSvc.message;
  showBrandLogo = this.spinnerSvc.showBrandLogo;

  private cdr = inject(ChangeDetectorRef);
  constructor(private spinnerSvc: SpinnerManualService) {}

  ngOnInit(): void {
    this.spinnerSvc.isLoading.subscribe(() => {
      this.cdr.markForCheck();
    });
  }
}
